webpackJsonp([35783957827783],{

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(24);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(35);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BlogIndex);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.filterList = function (event) {
	      var data = _this.getData();
	      var updatedList = JSON.parse(JSON.stringify(data));
	
	      updatedList = updatedList.filter(function (item) {
	        return item.post.frontmatter.title.toLowerCase().search(event.target.value.toLowerCase()) !== -1 || item.post.html.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
	      });
	      _this.setState({ items: updatedList });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BlogIndex.prototype.getData = function getData() {
	    return (0, _get2.default)(this, 'props.data.remark.posts').filter(function (x) {
	      return (0, _get2.default)(x, 'post.frontmatter.layout') === 'stih';
	    });
	  };
	
	  BlogIndex.prototype.componentWillMount = function componentWillMount() {
	    this.setState({ items: this.getData() });
	  };
	
	  /* clearText = () => {} */
	
	  BlogIndex.prototype.render = function render() {
	    var site = (0, _get2.default)(this, 'props.data.site.siteMetadata');
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: (0, _get2.default)(site, 'title'),
	        meta: [
	        /* { name: 'twitter:card', content: 'summary' }, */
	        {
	          property: 'vk:image',
	          content: (0, _get2.default)(site, 'url') + '/img/vkimage.jpg'
	        }, { property: 'og:title', content: (0, _get2.default)(site, 'title') }, { property: 'og:type', content: 'website' }, { property: 'og:description', content: (0, _get2.default)(site, 'description') }, { property: 'og:url', content: (0, _get2.default)(site, 'url') }, {
	          property: 'og:image',
	          content: (0, _get2.default)(site, 'url') + '/img/ogimage.jpg'
	        }]
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 mt-5' },
	          _react2.default.createElement('input', {
	            type: 'text',
	            className: 'form-control form-control-lg mb-3',
	            placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0438\u043B\u0438 \u0442\u0435\u043A\u0441\u0442 \u0434\u0443\u0445\u043E\u0432\u043D\u043E\u0433\u043E \u0441\u0442\u0438\u0445\u0430',
	            onChange: this.filterList
	          })
	        ),
	        _react2.default.createElement(List, { items: this.state.items })
	      )
	    );
	  };
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	var List = function List(_ref) {
	  var items = _ref.items;
	
	  return _react2.default.createElement(
	    'ul',
	    { className: 'col-12 mt-1' },
	    items.map(function (item, index) {
	      var path = (0, _get2.default)(item, 'post.frontmatter.path');
	      var title = (0, _get2.default)(item, 'post.frontmatter.title');
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: path, key: index },
	        _react2.default.createElement(
	          'li',
	          { className: 'list-group-item h5', key: index },
	          title
	        )
	      );
	    })
	  );
	};
	
	exports.default = BlogIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-8f109a21a8d00cefe83b.js